/*
 * Página de produto Bracci (blocos bracci-pdp-*).
 *
 * 1. Pré-venda: com o bloco "Bracci: Pré-venda" ([data-bpdp-stock]), troca o texto do
 *    botão de compra do Fabric, limita a quantidade ao que resta do limite e, acima do
 *    limite, desativa o botão ("Esgotado"). Mesma regra da loja antiga.
 * 2. Ambiente: chips de ambiente, "prefiro não selecionar", criar e remover
 *    ambientes. O valor vai num campo ligado ao formulário de compra (properties[Ambiente]).
 *    Ambientes criados/removidos e o último usado ficam no localStorage do cliente.
 * 3. Troca de variante: quando o Fabric troca a variante (evento product:select dos
 *    Standard Events), os blocos [data-bpdp-refresh] são trocados pela versão nova
 *    do HTML que o Fabric já buscou.
 */
(() => {
  if (window.BracciPdp) return;

  const STORAGE = {
    added: 'bracci:rooms:added',
    removed: 'bracci:rooms:removed',
    last: 'bracci:rooms:last',
  };

  function read(key, fallback) {
    try {
      const value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      /* navegação privada ou armazenamento bloqueado: só não lembra */
    }
  }

  /* ---------- 1. Pré-venda e botão de compra ---------- */

  function setButtonText(button, text) {
    if (!button || !text) return;
    const labelElement = button.querySelector('.add-to-cart-text');
    if (labelElement) {
      labelElement.textContent = text;
      return;
    }
    const node = [...button.childNodes].find((child) => child.nodeType === Node.TEXT_NODE && child.textContent.trim());
    if (node) node.textContent = text;
    else button.insertBefore(document.createTextNode(text), button.querySelector('.add-to-cart__added'));
  }

  function applyStock(root = document) {
    root.querySelectorAll('[data-bpdp-stock]').forEach((block) => {
      if (block.dataset.controlButton !== 'true') return;

      const section = block.closest('.shopify-section') || document;
      const button = section.querySelector('[ref="addToCartButton"], .product-details button[name="add"]');
      const quantity = section.querySelector('[ref="quantityInput"], .product-details input[name="quantity"]');
      const state = block.dataset.state;

      if (!button) return;

      if (!button.dataset.bpdpOriginal) {
        const node = [...button.childNodes].find((child) => child.nodeType === Node.TEXT_NODE && child.textContent.trim());
        button.dataset.bpdpOriginal = node ? node.textContent.trim() : '';
      }

      if (state === 'presale') {
        setButtonText(button, block.dataset.labelPresale);
        button.disabled = false;
        const max = Number(block.dataset.max);
        if (quantity && max > 0) {
          quantity.max = String(max);
          if (Number(quantity.value) > max) quantity.value = String(max);
        }
      } else if (state === 'soldout') {
        setButtonText(button, block.dataset.labelSoldout);
        button.disabled = true;
      } else if (button.dataset.bpdpOriginal) {
        setButtonText(button, button.dataset.bpdpOriginal);
      }
    });
  }

  /* ---------- 2. Ambiente ---------- */

  function initRoom(box) {
    if (box.dataset.bpdpReady) return;
    box.dataset.bpdpReady = 'true';

    const input = box.querySelector('[data-bpdp-room-input]');
    const chipsWrap = box.querySelector('[data-bpdp-room-chips]');
    const skip = box.querySelector('[data-bpdp-room-skip]');
    const status = box.querySelector('[data-bpdp-room-status]');
    const addButton = box.querySelector('[data-bpdp-room-add]');
    const form = box.querySelector('[data-bpdp-room-form]');
    const field = box.querySelector('[data-bpdp-room-field]');
    const optionalText = status ? status.textContent : '';
    if (!input || !chipsWrap) return;

    const defaults = [...chipsWrap.querySelectorAll('[data-bpdp-room-chip]')].map((chip) => chip.dataset.value);

    function makeChip(value) {
      const chip = document.createElement('span');
      chip.className = 'bpdp-room__chip';
      chip.dataset.bpdpRoomChip = '';
      chip.dataset.value = value;
      chip.dataset.custom = 'true';

      const pick = document.createElement('button');
      pick.type = 'button';
      pick.className = 'bpdp-room__pick';
      pick.setAttribute('aria-pressed', 'false');
      pick.textContent = value;
      chip.append(pick);
      return chip;
    }

    // Lista do cliente: acrescenta os ambientes criados por ele.
    // Não existe mais "remover"; limpa o que ficou guardado de versões anteriores
    // para nenhum ambiente padrão continuar escondido.
    write(STORAGE.removed, []);
    read(STORAGE.added, []).forEach((value) => {
      if (!chipsWrap.querySelector(`[data-value="${CSS.escape(value)}"]`)) chipsWrap.append(makeChip(value));
    });

    function select(value, remember = true) {
      chipsWrap.querySelectorAll('[data-bpdp-room-chip]').forEach((chip) => {
        const active = chip.dataset.value === value;
        chip.classList.toggle('is-active', active);
        chip.querySelector('.bpdp-room__pick')?.setAttribute('aria-pressed', String(active));
      });
      input.value = value || '';
      input.disabled = !value;
      if (status) status.textContent = value || optionalText;
      box.classList.toggle('has-value', Boolean(value));
      if (remember && value) write(STORAGE.last, value);
    }

    function setSkip(on) {
      if (skip) skip.checked = on;
      box.classList.toggle('is-skipped', on);
      chipsWrap.setAttribute('aria-disabled', String(on));
      if (on) {
        select('', false);
        if (status) status.textContent = skip?.nextElementSibling?.textContent.trim() || optionalText;
      }
    }

    // Escolha inicial
    const first = chipsWrap.querySelector('[data-bpdp-room-chip]')?.dataset.value;
    const last = read(STORAGE.last, '');
    if (box.dataset.default === 'first' && first) select(first, false);
    if (box.dataset.default === 'last_used' && last && chipsWrap.querySelector(`[data-value="${CSS.escape(last)}"]`)) {
      select(last, false);
    }

    box.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const pick = target.closest('.bpdp-room__pick');
      if (pick) {
        if (skip?.checked) setSkip(false);
        const value = pick.closest('[data-bpdp-room-chip]').dataset.value;
        select(input.value === value ? '' : value);
        return;
      }

      if (target.closest('[data-bpdp-room-add]')) {
        form.hidden = false;
        addButton.hidden = true;
        field?.focus();
        return;
      }

      if (target.closest('[data-bpdp-room-cancel]')) {
        form.hidden = true;
        addButton.hidden = false;
        if (field) field.value = '';
        return;
      }

      if (target.closest('[data-bpdp-room-confirm]')) addCustom();
    });

    function addCustom() {
      const value = (field?.value || '').trim().replace(/\s+/g, ' ');
      if (!value) {
        field?.focus();
        return;
      }
      if (!chipsWrap.querySelector(`[data-value="${CSS.escape(value)}"]`)) {
        chipsWrap.append(makeChip(value));
        if (!defaults.includes(value)) write(STORAGE.added, [...new Set([...read(STORAGE.added, []), value])]);
        else write(STORAGE.removed, read(STORAGE.removed, []).filter((item) => item !== value));
      }
      if (skip?.checked) setSkip(false);
      select(value);
      field.value = '';
      form.hidden = true;
      addButton.hidden = false;
    }

    field?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        addCustom();
      } else if (event.key === 'Escape') {
        form.hidden = true;
        addButton.hidden = false;
      }
    });

    skip?.addEventListener('change', () => setSkip(skip.checked));
  }

  /* ---------- 2b. Abas do produto ---------- */

  const DESKTOP = window.matchMedia('(min-width: 750px)');

  // No desktop, com "Abaixo da galeria", as abas (e os blocos que as acompanham)
  // vão para a coluna das fotos.
  // Um marcador guarda o lugar original, para voltarem no celular.
  function placeTabs(tabs) {
    const section = tabs.closest('.shopify-section');
    const media = section?.querySelector('.product-information__media');
    if (!tabs.bpdpAnchor) {
      tabs.bpdpAnchor = document.createComment('bracci-pdp-under-gallery');
      tabs.before(tabs.bpdpAnchor);
    }

    const underGallery = tabs.dataset.position === 'under_gallery' && DESKTOP.matches && media;
    if (underGallery) {
      if (tabs.parentElement !== media) media.append(tabs);
      tabs.classList.add('is-under-gallery');
    } else {
      if (tabs.bpdpAnchor.parentNode && tabs.previousSibling !== tabs.bpdpAnchor) tabs.bpdpAnchor.after(tabs);
      tabs.classList.remove('is-under-gallery');
    }
  }

  function activateTab(tabs, index, focus = false) {
    const buttons = [...tabs.querySelectorAll('[data-bpdp-tab-button]')];
    const panels = [...tabs.querySelectorAll('[data-bpdp-tab]')];
    buttons.forEach((button, i) => {
      const active = i === index;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
      if (active && focus) button.focus();
    });
    panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
  }

  function initTabs(tabs) {
    const panels = [...tabs.querySelectorAll('[data-bpdp-tab]')];
    const bar = tabs.querySelector('[data-bpdp-tabs-bar]');
    if (!bar) return;

    if (!tabs.dataset.bpdpReady) {
      tabs.dataset.bpdpReady = 'true';
      bar.innerHTML = '';
      panels.forEach((panel, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bpdp-tabs__tab';
        button.setAttribute('role', 'tab');
        button.id = `${panel.id}-tab`;
        button.setAttribute('aria-controls', `${panel.id}-panel`);
        button.dataset.bpdpTabButton = '';
        button.textContent = panel.dataset.title || `Aba ${index + 1}`;
        bar.append(button);

        const body = panel.querySelector('.bpdp-tab__body');
        if (body) {
          body.id = `${panel.id}-panel`;
          body.setAttribute('role', 'tabpanel');
          body.setAttribute('aria-labelledby', button.id);
        }

        // Cabeçalho da sanfona do celular
        const heading = panel.querySelector('.bpdp-tab__heading');
        if (heading && !heading.querySelector('button')) {
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'bpdp-tab__toggle';
          toggle.setAttribute('aria-expanded', 'false');
          toggle.innerHTML = `<span>${heading.textContent}</span><span class="bpdp-tab__sign" aria-hidden="true"></span>`;
          heading.textContent = '';
          heading.append(toggle);
        }

        // Primeira pergunta aberta
        if (panel.dataset.firstOpen === 'true') panel.querySelector('details')?.setAttribute('open', '');
      });

      bar.hidden = panels.length === 0;
      tabs.classList.add('is-ready');
      activateTab(tabs, 0);

      if (tabs.dataset.firstOpen === 'true' && panels[0]) {
        panels[0].classList.add('is-open');
        panels[0].querySelector('.bpdp-tab__toggle')?.setAttribute('aria-expanded', 'true');
      }

      bar.addEventListener('click', (event) => {
        const button = event.target.closest('[data-bpdp-tab-button]');
        if (!button) return;
        activateTab(tabs, [...bar.children].indexOf(button));
      });

      bar.addEventListener('keydown', (event) => {
        const buttons = [...bar.children];
        const current = buttons.indexOf(document.activeElement);
        if (current < 0) return;
        let next = current;
        if (event.key === 'ArrowRight') next = (current + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') next = (current - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault();
        activateTab(tabs, next, true);
      });

      tabs.addEventListener('click', (event) => {
        const toggle = event.target.closest('.bpdp-tab__toggle');
        if (toggle) {
          const panel = toggle.closest('[data-bpdp-tab]');
          const open = !panel.classList.contains('is-open');
          panel.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', String(open));
          return;
        }

        const more = event.target.closest('[data-bpdp-more]');
        if (more) {
          const panel = more.closest('[data-bpdp-tab]');
          const expanded = panel.classList.toggle('is-expanded');
          if (!more.dataset.more) more.dataset.more = more.textContent;
          more.textContent = expanded ? more.dataset.less : more.dataset.more;
        }
      });
    }

    placeTabs(tabs);
    checkCollapse(tabs);
  }

  // "Mostrar mais" só aparece quando o texto passa da altura escolhida.
  function checkCollapse(tabs) {
    tabs.querySelectorAll('.bpdp-tab--collapse').forEach((panel) => {
      const content = panel.querySelector('[data-bpdp-collapse]');
      const more = panel.querySelector('[data-bpdp-more]');
      if (!content || !more) return;
      const limit = parseFloat(getComputedStyle(panel).getPropertyValue('--bpdp-tab-max')) || 240;
      // Aba escondida não tem altura: mede com ela visível por um instante.
      panel.classList.add('is-measuring');
      const tooTall = content.scrollHeight > limit + 24;
      panel.classList.remove('is-measuring');
      more.hidden = !tooTall;
      panel.classList.toggle('is-collapsible', tooTall);
    });
  }

  function initAllTabs(root = document) {
    root.querySelectorAll('[data-bpdp-tabs]').forEach(initTabs);
  }

  // Abas e blocos que acompanham as abas (ex.: Bracci: Destaques, data-bpdp-under)
  // vão juntos para a coluna da galeria, na ordem em que estão na página.
  const placeAllTabs = () => document.querySelectorAll('[data-bpdp-tabs], [data-bpdp-under]').forEach(placeTabs);
  DESKTOP.addEventListener('change', placeAllTabs);
  // Reserva: alguns navegadores não avisam a troca do media query ao redimensionar.
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(placeAllTabs, 150);
  });

  /* ---------- 3. Troca de variante ---------- */

  function refreshFrom(html) {
    document.querySelectorAll('[data-bpdp-refresh][data-block-id]').forEach((element) => {
      const fresh = html.querySelector(`[data-bpdp-refresh][data-block-id="${element.dataset.blockId}"]`);
      if (fresh) element.replaceWith(document.importNode(fresh, true));
    });
    applyStock();
    applyAppMessage();
  }

  async function listenVariantChanges() {
    let eventName = 'product:select';
    try {
      const events = await import('@shopify/events');
      eventName = events.StandardEvents?.productSelect || eventName;
    } catch (error) {
      /* sem importmap: usa o nome padrão */
    }

    document.addEventListener(
      eventName,
      (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        event.promise
          ?.then(({ detail }) => {
            if (detail?.html) refreshFrom(detail.html);
            else applyStock();
          })
          .catch(() => {});
      },
      true
    );
  }

  /* ---------- Início ---------- */

  /* ---------- Pré-venda do app Globo Pre-Order: mensagem do perfil ---------- */

  // Com o app embed do Globo ligado, a página traz window.GloboPreorderParams com os
  // perfis de pré-venda. A caixa de pré-venda passa a mostrar a mensagem do perfil
  // (ex.: "O envio do seu pedido será feito a partir de 26/10/2026"), que é a mesma
  // que a loja antiga mostrava. Sem o app, fica a data do metafield ou o texto padrão.
  function appPresaleMessage(productId, variantId) {
    const params = window.GloboPreorderParams;
    const settings = params?.preorderSettings;
    if (!settings?.products || !settings.profiles) return '';
    const variants = settings.products[String(productId)];
    const profileId = variants?.[String(variantId)] ?? (variants ? Object.values(variants)[0] : null);
    const profile = profileId != null ? settings.profiles[String(profileId)] : null;
    if (!profile || String(profile.status) === '0') return '';
    let message = {};
    try {
      message = typeof profile.message === 'string' ? JSON.parse(profile.message) : profile.message || {};
    } catch (error) {
      return '';
    }
    const texts = message[params.locale] || message.default || {};
    return (texts.aboveMessage || texts.bellowMessage || '').trim();
  }

  function applyAppMessage(root = document) {
    root.querySelectorAll('[data-bpdp-stock][data-state="presale"][data-app-message="true"]').forEach((block) => {
      const text = appPresaleMessage(block.dataset.productId, block.dataset.variantId);
      const date = block.querySelector('[data-bpdp-presale-date]');
      if (!text || !date) return;
      date.textContent = text;
      date.classList.add('bpdp-presale__date--app');
    });
  }

  function init(root = document) {
    applyStock(root);
    applyAppMessage(root);
    root.querySelectorAll('[data-bpdp-room]').forEach(initRoom);
    initAllTabs(root);
    root.querySelectorAll('[data-bpdp-under]').forEach(placeTabs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  // O Fabric define o botão de compra depois; reaplica quando ele termina de carregar.
  window.addEventListener('load', () => {
    applyStock();
    applyAppMessage();
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    applyStock();
    // Editor: selecionar uma aba no painel abre essa aba.
    const panel = event.target.closest?.('[data-bpdp-tab]');
    const tabs = panel?.closest('[data-bpdp-tabs]');
    if (tabs) activateTab(tabs, [...tabs.querySelectorAll('[data-bpdp-tab]')].indexOf(panel));
  });
  listenVariantChanges();

  window.BracciPdp = { applyStock, init };
})();
